import { createStore } from '@xstate/store';

const LOCAL_STORAGE_KEY = 'roadmap_2026_task_id_counter';

// Load from localStorage
function loadCounter(): number {
  try {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) {
      const num = parseInt(saved, 10);
      if (!isNaN(num)) return num;
    }
  } catch {
    // ignore
  }
  return 0;
}

// Save to localStorage
function saveCounter(counter: number): void {
  localStorage.setItem(LOCAL_STORAGE_KEY, String(counter));
}

interface TaskIdContext {
  counter: number;
}

export const taskIdStore = createStore({
  context: {
    counter: loadCounter(),
  } as TaskIdContext,

  on: {
    'counter.increment': (ctx) => {
      const newCounter = ctx.counter + 1;
      saveCounter(newCounter);
      return { counter: newCounter };
    },

    'counter.set': (ctx, event: { value: number }) => {
      const newCounter = Math.max(ctx.counter, event.value);
      saveCounter(newCounter);
      return { counter: newCounter };
    },

    'counter.import': (ctx, event: { value: number }) => {
      // Bei Import: Nimm den höheren Wert
      const newCounter = Math.max(ctx.counter, event.value);
      saveCounter(newCounter);
      return { counter: newCounter };
    },
  },
});

// Persist on every change
taskIdStore.subscribe((snapshot) => {
  saveCounter(snapshot.context.counter);
});

// Helper: Get next ID and increment counter
export function getNextTaskId(): string {
  const current = taskIdStore.getSnapshot().context.counter;
  taskIdStore.send({ type: 'counter.increment' });
  return `TASK-${String(current + 1).padStart(4, '0')}`;
}

// Helper: Get current counter value (for export)
export function getTaskIdCounter(): number {
  return taskIdStore.getSnapshot().context.counter;
}

// Helper: Import counter (for import)
export function importTaskIdCounter(value: number): void {
  taskIdStore.send({ type: 'counter.import', value });
}

export type TaskIdStore = typeof taskIdStore;
